import { cn } from "#/lib/utils";

/**
 * Real Blue Rock Concrete logo, recolored to the brand flame accent
 * (transparent webp, made for dark backdrops).
 * Same asset the nav uses; size with className (defaults to h-14).
 */
export function Logo({ className }: { className?: string }) {
  return (
    <img
      src="/blue-rock-logo-flame.webp"
      alt="Blue Rock Concrete"
      width={480}
      height={273}
      loading="lazy"
      decoding="async"
      className={cn("h-14 w-auto", className)}
    />
  );
}
